// This is a direct re-export of the buffer module
import * as buffer from 'buffer';

// Ensure Buffer is available globally
if (typeof window !== 'undefined') {
    window.Buffer = buffer.Buffer;
    // Ensure there's no reference to 'dist' that could be causing the error
    window.global = window;
}

// Explicitly export these for any module that might be importing them
export default buffer;
export const Buffer = buffer.Buffer; 